import { render, staticRenderFns } from "./CoPermissions.vue?vue&type=template&id=69c4132b&"
import script from "./CoPermissions.vue?vue&type=script&lang=ts&"
export * from "./CoPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports